<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <div class="bg-white p-3">
      <div class="content-options text-center py-5">
        <h2 class="fw-800 text-color10 ls-25 text-uppercase font-size-large">
          {{ $t('request_campaign_title') }}
        </h2>
        <p class="text-center text-uppercase font-size-xRegular col-lg-6 mx-auto">
          {{ $t('request_campaign_subtitle') }}
        </p>
        <template v-if="user">
          <form @submit.prevent="submit" class="default-form text-start col-lg-7 mx-auto" v-if="!sent">
            <div class="form-group mb-3">
              <label class="form-label fw-bold">{{ $t('type') }}</label>
              <input type="text" class="form-control" v-model="form.type" readonly />
            </div>
            <div class="form-group mb-3">
              <label class="form-label fw-bold">{{ $t('email') }}</label>
              <input type="email" class="form-control" placeholder="email@email.com.br" v-model.trim="$v.form.email.$model" />
            </div>
            <div class="form-group mb-3">
              <label class="form-label fw-bold">{{ $t('phone') }}</label>
              <PhoneInput
                v-model.trim="$v.form.phone.$model"
                :country="user.company.country"
              />
            </div>
            <div class="form-group mb-3">
              <label class="form-label fw-bold">{{ $t('description') }}</label>
              <textarea class="form-control" v-model="$v.form.message.$model"></textarea>
            </div>

            <div class="text-center mt-5">
              <Button
                class="btn-color10 btn-lg"
                :loading="loader"
                :disabled="$v.$invalid"
                @click="submit"
              >
                {{ $t('send') }}
              </Button>
            </div>
          </form>
          <div v-else>
            <p class="text-center font-size-regular col-md-6 mx-auto mt-5">{{ $t('request_campaign_success') }}</p>
            <div class="text-center mt-4">
              <router-link :to="{ name: 'campaigns.create' }" class="btn btn-color10">{{ $t('back') }}</router-link>
            </div>
          </div>
        </template>
      </div>
    </div>
  </MainLayout>
</template>

<script>

import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import variables from '@/mixins/variables'
import { email, required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import MainLayout from '@/components/layouts/MainLayout'
import PhoneInput from '@/components/common/Input/PhoneInput'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'

export default {
  mixins: [variables],
  components: {
    Button,
    MainLayout,
    PhoneInput,
    Shortcuts
  },
  data () {
    return {
      form: {
        email: '',
        phone: '',
        type: '',
        message: ''
      },
      loader: false,
      sent: false
    }
  },
  metaInfo () {
    return {
      title: 'Solicitar campanha'
    }
  },
  validations () {
    return {
      form: {
        email: { required, email },
        phone: { required },
        type: { required },
        message: { required }
      }
    }
  },
  created () {
    this.form.type = this.$route.query.type
    if (this.user) {
      this.form.email = this.user.email
      this.form.phone = this.user.phone
    }
  },
  watch: {
    user (newUser) {
      this.form.email = newUser.email
      this.form.phone = newUser.phone
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    async submit () {
      this.loader = true
      try {
        await CampaignsService.requestCampaign(this.form)
        this.sent = true
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
.content-options {
  background-color: #f4f4f4;
}
</style>
